import React from 'react'
import styled from 'styled-components'
import Pagination from 'react-js-pagination'
import { BLUE, ALMOST_WHITE, LIGHTEST_GRAY, TEAL } from 'components/styles'

const Container = styled.div`
  & ul {
    display: flex;
    padding-left: 0;
    list-style: none;
  }

  & li {
    width: 2em;
    height: 2em;
    position: relative;
    margin-left: -1px;
    line-height: 1.25;
    color: ${BLUE};
    background-color: #FFF;
    border: 0.5px solid ${LIGHTEST_GRAY};
    border-radius: 15%;
    margin: 0.1em;
    text-align: center;
    user-select: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      color: darken(${BLUE}, 15%);
      text-decoration: none;
      background-color: ${ALMOST_WHITE};
      border-color: #ddd;
    }

    & a {
      text-decoration: none;

    }

    &.active {
      z-index: 2;
      color: #FFF;
      background-color: ${TEAL};
      border-color: ${TEAL};
      color: #FFF;
      pointer-events: none;
      cursor: default;
      & a {
        color: #FFF
      }
    }

    &.disabled {
      color: #868e96;
      pointer-events: none;
      background-color: #FFF;
      border-color: ${ALMOST_WHITE};
    }
  }
`

const Pag = (props) => {
  return (
    <Container>
      <Pagination {...props} />
    </Container>
  )
}

export default Pag



// WEBPACK FOOTER //
// ./src/components/shared/Pagination.js